module.exports = __webpack_public_path__ + "img/selected4-min.232f448e.png";